// extracted by mini-css-extract-plugin
export default {"card":"VideoTrailerCard_card__32Mb3","main_image":"VideoTrailerCard_main_image__2vKJL","title_text":"VideoTrailerCard_title_text__gP1zI"};